import {calculateAgeTruncated} from '../age-utils';
import {
  isProvinceRequiresTrusteeForBeneficiaryUnder18YearsOld,
  isProvinceRequiresTrusteeForBeneficiaryUnder19YearsOld,
  Province,
} from '../province';

export function isTrusteeNeeded(birthday: Date | undefined, province: Province | undefined): boolean {
  if (!birthday || isNaN(birthday.getTime())) {
    return false;
  }

  return (
    (calculateAgeTruncated(birthday) < 19 &&
      isProvinceRequiresTrusteeForBeneficiaryUnder19YearsOld(province)) ||
    (calculateAgeTruncated(birthday) < 18 && isProvinceRequiresTrusteeForBeneficiaryUnder18YearsOld(province))
  );
}
